// extracted by mini-css-extract-plugin
module.exports = {"HeroPanel":"HeroPanel-HeroPanel-3hmS53","Gradient":"HeroPanel-Gradient-2YHP68","Content":"HeroPanel-Content-3mo8mB"};